<template>
    <v-app>
      <div class="contentWrapper">
          <ul class="nav nav-pills">
              <li class="nav-item">
                  <router-link class="nav-link" active-class="active" to="/admin/clients">Clients</router-link>
              </li>
              <!--
              <li class="nav-item">
                  <router-link class="nav-link" active-class="active" to="/admin/contrats">Contrats</router-link>
              </li>
              -->
              <li class="nav-item">
                  <router-link class="nav-link" active-class="active" to="/admin/evenements">Évènements</router-link>
              </li>
              <li class="nav-item">
                  <router-link class="nav-link" active-class="active" to="/admin/depots">Dépôts</router-link>
              </li>
              <li class="nav-item">
                  <router-link class="nav-link" active-class="active" to="/admin/rapports">Rapports</router-link>
              </li>
              <li class="nav-item">
                  <router-link class="nav-link" active-class="active" to="/admin/deconnexion">Déconnexion</router-link>
              </li>
          </ul>
      </div>
      <div style="margin-left:10px;">
          <slot></slot>
      </div>
    </v-app>
</template>

<style lang="css" scoped>
/* @import '~bootstrap/dist/css/bootstrap.css';
@import '~bootstrap-vue/dist/bootstrap-vue.css'; */
/* @import '../../node_modules/bootstrap/css/bootstrap.css'; */
</style>

<style lang="css" scoped>

  /* .nav-pills .mytab .nav-link:not(.active) {
    background-color: red !important;
  }

  .nav-pills .mytab .nav-link {
    background-color: blue !important;
  }

  .tab-content > .tab-pane {
    border: 1px solid;
    border-left: 0px none;
  } */

</style>

<script>
import auth from '@/auth'
export default {
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/TemplateAdmin.vue